class NavMenu extends HTMLElement {
  constructor() {
    super();
  }

  get shouldStick() {
    const shouldStick = this.getAttribute('should-stick', false);
    if(shouldStick === null || shouldStick === undefined || shouldStick === 'false') {
      return false;
    }
    return true;
  }

  set shouldStick(value) {
    this.setAttribute('should-stick', `${value}`)
  }

  connectedCallback() {
    this.navOpen = this.querySelector('#NavDrawer-Open');
    this.navOpen.addEventListener('click', this.open.bind(this));
    document.addEventListener("DOMContentLoaded", () => {
      this.initiateSticky();
    });
  }
  
  initiateSticky() {
    if(this.shouldStick) {
      this.dataset.state = 'fixed';
      const section = this.closest('section');
      const targets = [section]
      const colorScheme = this.getAttribute('color-scheme');
      const stickyScheme = this.getAttribute('sticky-color-scheme');
      section.style.setProperty('--sticky-offset-start', `-${section.offsetHeight}`);
      section.style.setProperty('--sticky-offset-end', `0px`);
      section.style.top = '0';
      if(this.getAttribute('should-stick') === 'announcement') {
        const previous = section.previousSibling;
        if(previous.querySelector('announcement-bar')) {
          const getStickyOffset = () => {
            const previous = this.closest('section').previousSibling;
            if(previous.querySelector('announcement-bar')) {
              section.style.setProperty('--sticky-offset-start', `-${this.offsetHeight}`);
              section.style.setProperty('--sticky-offset-end', `${previous.offsetHeight}`);
            }
          }
          previous.classList.remove('z-layout');
          previous.classList.add('z-pop');
          previous.style.setProperty('--sticky-offset-start', `-${previous.offsetHeight}`);
          previous.style.setProperty('--sticky-offset-end', `0px`);
          targets.push(previous);
          getStickyOffset();
          window.addEventListener('resize', getStickyOffset);
        }
      }
      gsap.registerEffect({
        name: "navSlideIn",
        effect: (targets, config) => {
          return gsap.fromTo(
            targets, 
            {
              y: function(index, target) {
                const style = getComputedStyle(target);
                return style.getPropertyValue('--sticky-offset-start')
              }
            }, 
            { 
              duration: config.duration, 
              delay: config.delay,
              ease: "power2.inOut", 
              y: function(index, target) {
                const style = getComputedStyle(target);
                return style.getPropertyValue('--sticky-offset-end')
              }
            }
          )
        },
        defaults: { duration: 1, delay: '0.5' }
      })
      gsap.registerEffect({
        name: "navSlideOut",
        effect: (targets, config) => {
          return gsap.fromTo(
            targets,
            { 
              duration: config.duration, 
              delay: config.delay,
              ease: "power2.inOut", 
              y: function(index, target) {
                const style = getComputedStyle(target);
                return style.getPropertyValue('--sticky-offset-end')
              }
            }, 
            {
              y: function(index, target) {
                const style = getComputedStyle(target);
                return style.getPropertyValue('--sticky-offset-start')
              }
            },
          )
        },
        defaults: { duration: 1, delay: '0.5' }
      })
      
      const swapColorSchemes = (from, to) => {
        this.classList.remove(from);
        this.classList.add(to);
      }

      const onEnter = () => {
        targets.forEach((i) => {
          i.classList.add('sticky-element')
        });
        gsap.effects.navSlideIn(targets);
        swapColorSchemes(colorScheme, stickyScheme);
        this.dataset.state = 'sticky';
      }
      const onLeave = () => {
        gsap.effects.navSlideOut(targets);
        gsap.delayedCall('0.5', () => {
          reset();
        })
      }
      const reset = () => {
        gsap.killTweensOf(targets)
        targets.forEach((i) => {
          i.classList.remove('sticky-element')
          i.style.transform = 'translate(0px, 0px)'
        });
        swapColorSchemes(stickyScheme, colorScheme);
        this.dataset.state = 'fixed';
      }

      const handleScroll = (entries) => {
        const spotIsVisible = entries[0].isIntersecting;
        if(spotIsVisible) {
          if(entries[0].boundingClientRect.y > 300) {
            reset();
          }
          else {
            onLeave();
          }
        }
        else {
          onEnter();
        }
      }

      const spot = document.createElement('div');
      spot.style.position = 'absolute';
      spot.style.transform = 'translateY(100dvh)'
      document.querySelector('body').append(spot);
      const observer = new IntersectionObserver(handleScroll, {
        root: null,
        rootMargin: "0px",
        threshold: 0
      });
      observer.observe(spot);
    }
  }

  open(event) {
    event.preventDefault();
    document.querySelector('nav-drawer').style.transform = "translateX(0)";
    document.body.classList.add('overflow-hidden');
  }

  close(event) {
    event.preventDefault();
    document.querySelector('nav-drawer').style.transform = "translateX(-100%)";
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('nav-menu', NavMenu)

class NavDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.target === this && evt.code === 'Escape' && this.close(evt));
    this.querySelector('#NavDrawer-closeSelf').addEventListener('click', this.close.bind(this))
  }

  close(event) {
    document.querySelector('nav-menu').close(event);
  }

  open(event) {
    document.querySelector('nav-menu').open(event);
  }
}

customElements.define('nav-drawer', NavDrawer)

class NavSubdrawer extends HTMLElement {
  constructor() {
    super();
    this.ref = this.dataset.ref;
    this.addEventListener('keyup', (evt) => evt.target === this && evt.code === 'Escape' && this.close(evt));
    document.getElementById(`nav-subdrawer-link-${this.ref}`).addEventListener('click', this.open.bind(this))
    this.querySelector(`#nav-subdrawer-closeself-${this.ref}`).addEventListener('click', this.close.bind(this))
    this.querySelector('.caret-left').addEventListener('click', this.close.bind(this))
  }

  open(event) {
    event.preventDefault();
    this.style.transform = "translateX(0)";
  }

  close(event) {
    event.preventDefault();
    this.style.transform = "translateX(-110%)";
  }
}

customElements.define('nav-subdrawer', NavSubdrawer)

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.menu = this.querySelector('ul');
    this.caretDown = this.querySelector('.caret-down');
    this.caretUp = this.querySelector('.caret-up');
    this.isOpen = false;
    this.querySelector('label').addEventListener('click', this.toggle.bind(this));
    this.addEventListener('blur', this.close.bind(this))
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.menu.style.visibility = 'visible';
    this.menu.style.opacity = 1;
    this.caretDown.classList.add('hidden');
    this.caretUp.classList.remove('hidden');
    this.isOpen = true;
    this.setFocus();
  }

  close(event = false) {
    if(event && this.contains(event.relatedTarget)) {
      return false;
    }
    this.menu.style.visibility = 'hidden';
    this.menu.style.opacity = 0;
    this.caretDown.classList.remove('hidden');
    this.caretUp.classList.add('hidden');
    this.isOpen = false;
  }

  setFocus() {
    window.setTimeout(() => this.focus(), 100);
  }
}

customElements.define('menu-drawer', MenuDrawer)

class NavMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.menu = this.querySelector('ul');
    this.caretDown = this.querySelector('.caret-down');
    this.caretUp = this.querySelector('.caret-up');
    this.isOpen = false;
    this.calcHeight()
    this.querySelector('label').addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.menu.style.height = `${this.height}px`;
    this.menu.style.opacity = 1;
    this.caretDown.classList.add('hidden');
    this.caretUp.classList.remove('hidden');
    this.isOpen = true;
  }

  close() {
    this.menu.style.height = '0';
    this.menu.style.opacity = 0;
    this.caretDown.classList.remove('hidden');
    this.caretUp.classList.add('hidden');
    this.isOpen = false;
  }

  calcHeight() {
    const clone = this.menu.cloneNode(true);
    Object.assign(clone.style, {
      overflow: 'visible',
      height: 'auto',
      maxHeight: 'none',
      opacity: '0',
      visibility: 'hidden',
      display: 'block'
    });
    this.menu.after(clone);
    this.height = clone.offsetHeight;
    clone.remove();
  }
}

customElements.define('nav-menu-drawer', NavMenuDrawer)